module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "title": "MOVE TO FOLDER",
      "id": _vm.id,
      "value": _vm.value,
      "extra-class": "modal-sm"
    },
    on: {
      "shown": _vm.clear,
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('button', {
          staticClass: "btn green mt-ladda-btn ladda-button remove-participant-control",
          attrs: {
            "data-style": "expand-left"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.moveToFolder()
            }
          }
        }, [_c('span', {
          staticClass: "ladda-label"
        }, [_vm._v("OK")])]), _vm._v(" "), _c('button', {
          staticClass: "btn default",
          attrs: {
            "data-dismiss": "modal"
          }
        }, [_vm._v("Cancel")])]
      },
      proxy: true
    }])
  }, [_c('form', {
    attrs: {
      "data-vv-scope": "move-to-folder"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('vue-select', {
    attrs: {
      "options": _vm.accountFolders,
      "label": "name",
      "value": "id",
      "multiple": false,
      "placeholder": "Select folder"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._l((option.lvl), function(idx) {
          return (option.lvl > 1) ? [_vm._v("  ")] : _vm._e()
        }), _vm._v("\n          " + _vm._s(option.name) + "\n        ")]
      }
    }]),
    model: {
      value: (_vm.targetFolder),
      callback: function($$v) {
        _vm.targetFolder = $$v
      },
      expression: "targetFolder"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00bec9a9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/reports/MoveToFolderModal.vue
// module id = 1532
// module chunks = 1